import React from 'react';
import { UpgradeNowStyled } from './styled';
import CustomBadge from '../CustomBadge';
import { BlockStack, Text, TextProps } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

interface UpgradeNowProps extends Omit<TextProps, 'as' | 'children'> {
  label?: string;
}

const UpgradeNow: React.FC<UpgradeNowProps> = ({ label, ...props }) => {
  const { t } = useTranslation('pricing');

  return (
    <UpgradeNowStyled>
      <BlockStack gap="150">
        {label ? (
          <Text {...props} as="span">
            {label}
          </Text>
        ) : null}
        <div className="upgrade-now">
          {t('upgrade_now')} <CustomBadge />
        </div>
      </BlockStack>
    </UpgradeNowStyled>
  );
};

export default UpgradeNow;
